/**
 * Categories Feature API
 */

import apiClient from '../../../shared/services/apiClient';
import { readSavedBusiness } from '../../../utils/businessSelection';

// Pickers list the categories of the business picked in the sidebar; with
// "All Businesses" they list every business's. The server applies the same rule.
export function withSelectedBusiness(params) {
  const p = params || {};
  if (p.business_id !== undefined && p.business_id !== null && p.business_id !== '') return p;
  const selected = readSavedBusiness();
  return typeof selected === 'number' ? { ...p, business_id: selected } : p;
}

export const categoriesAPI = {
  getAll: (params) => apiClient.get('/categories', { params: withSelectedBusiness(params) }),
  getById: (id) => apiClient.get(`/categories/${id}`),
  match: (name, type) => apiClient.get('/categories/match', { params: withSelectedBusiness({ name, type }) }),
  create: (data) => apiClient.post('/categories', data),
  update: (id, data) => apiClient.put(`/categories/${id}`, data),
  delete: (id, params) => apiClient.delete(`/categories/${id}`, { params }),
};

export default categoriesAPI;